import { DynamicComponent } from '@gik/core/components/DynamicComponent';
import { withTitle } from '@gik/core/hocs/withTitle';
import { FeaturesPage } from '@gik/marketing/pages/FeaturesPage';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';

export default function FeaturesPageComp() {
  return withTitle(
    'Features',
    <DynamicComponent noViewport>
      <FeaturesPage />
    </DynamicComponent>
  );
}

FeaturesPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};
